import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiLogin, apiRegister, apiLogout, apiMe, apiRefresh } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed
  const [checked, setChecked] = useState(false);

  const refresh = useCallback(async () => {
    try {
      setUser(await apiMe());
    } catch {
      setUser(false);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Keep the session alive quietly: renew every 45 min and whenever the tab
  // regains focus, so users stay signed in across days.
  useEffect(() => {
    if (!user) return;
    const iv = setInterval(() => { apiRefresh().catch(() => {}); }, 45 * 60 * 1000);
    const onVis = () => { if (document.visibilityState === "visible") apiRefresh().catch(() => {}); };
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", onVis); };
  }, [user]);

  const login = async (email, password) => { const u = await apiLogin(email, password); setUser(u); return u; };
  const register = async (payload) => { const u = await apiRegister(payload); setUser(u); return u; };
  const logout = async () => { try { await apiLogout(); } catch {} setUser(false); };

  return (
    <AuthContext.Provider value={{ user, checked, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
